<app-mes-informations-form
  label="Mes informations"
  [initialValue]="informations"
  [loginAlreadyExists]="loginAlreadyExists"
  (informationsChanged)="onInformationsChanged($event)"
  (disableNextButton)="onDisableNextButton($event)"
  (verifyLogin)="onVerifyLogin($event)"
  (cleanLoginError)="onCleanLoginError()"
></app-mes-informations-form>
